(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-custom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlideshow(root) {
      if (!root || root.dataset.slideshowInitialized === 'true') return;
      root.dataset.slideshowInitialized = 'true';

      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-slide-dot]'));
      const prevButton = root.querySelector('[data-slide-prev]');
      const nextButton = root.querySelector('[data-slide-next]');
      const speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;

      if (slides.length < 2) return;

      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      let timer = null;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function goToSlide(index) {
        const nextIndex = (index + slides.length) % slides.length;

        slides[activeIndex].classList.remove('is-active');
        slides[activeIndex].setAttribute('aria-hidden', 'true');

        if (dots[activeIndex]) {
          dots[activeIndex].classList.remove('is-active');
          dots[activeIndex].setAttribute('aria-selected', 'false');
        }

        activeIndex = nextIndex;

        slides[activeIndex].classList.add('is-active');
        slides[activeIndex].removeAttribute('aria-hidden');

        if (dots[activeIndex]) {
          dots[activeIndex].classList.add('is-active');
          dots[activeIndex].setAttribute('aria-selected', 'true');
        }
      }

      function nextSlide() {
        goToSlide(activeIndex + 1);
      }

      function previousSlide() {
        goToSlide(activeIndex - 1);
      }

      function startAutoplay() {
        if (prefersReducedMotion) return;
        stopAutoplay();
        timer = window.setInterval(nextSlide, speed);
      }

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goToSlide(parseInt(dot.dataset.slideIndex, 10));
          startAutoplay();
        });
      });

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          nextSlide();
          startAutoplay();
        });
      }

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          previousSlide();
          startAutoplay();
        });
      }

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      startAutoplay();
    }

    function initAll() {
      document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const slideshow = event.target.querySelector('[data-slideshow]');
      if (slideshow) {
        slideshow.dataset.slideshowInitialized = 'false';
        initSlideshow(slideshow);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
